import React, { useEffect, useState } from "react";

import axios from "../../../../node_modules/axios/index";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Table, Dropdown, Form } from "react-bootstrap";
import Loader from "../../Common/Loader";
import LoaderButton from "../../Common/LoaderButton";
import NoDataFound from "../../Common/NoDataFound";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import Alert from "../../Common/Alert";
import {
  logOut,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import constatntMessages from "../../../constants/constatntMessages";
import { fetchIpAddress } from "../../../helpers/commonHelpers";
import { handleApiError } from "../../../helpers/errorResponseHelper";
import BackButton from "../../Common/Backbutton";
import SmallLoaderButton from "../../Common/SmallLoaderButton";

const Designation = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const employeeData = useSelector((state) => state.user);

  const [screenSize, setScreenSize] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (employeeData?.userData) {
      if (employeeData.userData.isAdmin === false) {
        navigate("/page-not-found");
      }
    }
  }, [employeeData?.userData]);

  const organizationId = userData?.organizationId;
  const accessToken = localStorage.getItem("accessToken");
  const [formValues, setFormValues] = useState({ name: "" });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  //List designation
  const [designation, setDesignation] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const maxOption = Math.ceil(totalCount / 5) * 5;
  const [order, setOrder] = useState(-1);
  const [isFetching, setIsFetching] = useState(false);
  const excludeHtml = /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}\[\]]+$/;

  //EDIT Designation
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [designationName, setDesignationName] = useState("");
  const [editformValues, setEditFormValues] = useState({
    name: "",
  });
  const [isConfirming, setIsConfirming] = useState(false);

  //DELETE Designation
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [designationToDelete, setDesignationToDelete] = useState(null);
  const [searchError, setSearchError] = useState("");

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
    setFormValues({ ...formValues, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };
  const isValidate = () => {
    let isValid = true;
    const errors = {};

    if (!formValues.name.trim()) {
      errors.name = "Designation is required";
      isValid = false;
    } else if (!excludeHtml.test(formValues.name)) {
      errors.name = constatntMessages.invalidInput;
      isValid = false;
    } else if (
      formValues.name.trim().length < 2 ||
      formValues.name.trim().length > 100
    ) {
      errors.name = "Designation must be between 2-100  characters";
      isValid = false;
    } else {
      delete errors.name;
    }

    setErrors(errors);
    return isValid;
  };

  const dsnameValidationCheck = () => {
    const newErrors = { ...errors };

    if (!formValues.name.trim()) {
      newErrors.name = "Designation is required";
    } else if (!excludeHtml.test(formValues.name)) {
      newErrors.name = constatntMessages.invalidInput;
    } else if (
      formValues.name.trim().length < 2 ||
      formValues.name.trim().length > 100
    ) {
      newErrors.name = "Designation must be between 2 - 100  characters";
    }
    setErrors(newErrors);
    return newErrors;
  };

  //Create designation
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const trimmedFormValues = {
      ...formValues,
      name: formValues.name.trim(),
    };
    if (isValidate()) {
      try {
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/V1/designation/createDesignation`,
          { ...trimmedFormValues, organizationId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
              ip: await fetchIpAddress(),
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data.success) {
          setFormValues({ name: "" });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          fetchDesignationData();
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } catch (error) {
        if (handleApiError(error)) return;

        console.log(
          "Error while creating designation",
          error.response?.data?.message || error.message
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const fetchDesignation = async (bodyData) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      setIsFetching(true);
      const headerObject = {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
        params: { limit, page, order },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/V1/designation/listDesignation`,
        bodyData,
        headerObject
      );
      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        dispatch(setInValidUser(false));
      }

      const data = response.data.data || {};

      setDesignation(data.designationList || []);
      setTotalCount(data.totalCount || 0);
      setIsFetching(false);
    } catch (error) {
      console.log("Error while Fetching Designation:", error);
      if (handleApiError(error)) return;
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    document.title = "Designation: MinutesVault";
    fetchDesignationData();
  }, [searchKey, page, limit, order]);

  const handleSearch = (event) => {
    const value = event.target.value;

    setSearchKey(value);
    setPage(1);
    if (/[<>]/.test(value)) {
      setSearchError(constatntMessages.titleRegexError);
    } else {
      setSearchError("");
    }
  };

  const fetchDesignationData = async () => {
    const bodyData = searchKey
      ? { searchKey, organizationId }
      : { organizationId };

    await fetchDesignation(bodyData);
  };
  const handleClearSearch = () => {
    setSearchKey("");
    setPage(1);
    fetchDesignationData();
  };

  //Row per page
  const handleRowsPerPageChange = (e) => {
    setLimit(parseInt(e.target.value, 10));
    setPage(1);
  };
  const fromDataCount = designation.length === 0 ? 0 : (page - 1) * limit + 1;
  const toDataCount = (page - 1) * limit + designation.length;
  const totalPage = Math.ceil(totalCount / limit);

  const editDesignationValidationCheck = () => {
    const errors = {};

    if (!designationName.trim()) {
      errors.designationName = "Designation is required";
    } else if (!excludeHtml.test(designationName)) {
      errors.designationName = constatntMessages.invalidInput;
    } else if (
      designationName.trim().length < 2 ||
      designationName.trim().length > 100
    ) {
      errors.designationName = "Designation must be between 2-100  characters";
    }

    setErrors(errors);
    return errors;
  };

  const isEditValid = () => {
    const errors = {};

    if (!designationName.trim()) {
      errors.designationName = "Designation is required";
    } else if (!excludeHtml.test(designationName)) {
      errors.designationName = constatntMessages.invalidInput;
    } else if (
      designationName.trim().length < 2 ||
      designationName.trim().length > 100
    ) {
      errors.designationName = "Designation must be between 2-100  characters";
    } else {
      delete errors.designationName;
    }

    setErrors(errors);
    return errors;
  };

  const handlEditDesignation = async (e) => {
    setIsEditLoading(true);
    const newErrors = isEditValid();
    if (Object.keys(newErrors).length === 0) {
      try {
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        setErrors({});
        const updatedDesignation = {
          name: designationName.trim(),
          organizationId,
        };

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/V1/designation/editDesignation/${selectedDesignation._id}`,
          updatedDesignation,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
              ip: await fetchIpAddress(),
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data.success) {
          setEditFormValues({ name: "" });
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setSelectedDesignation(null);
          setShowEditModal(false);
          fetchDesignationData();
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setShowEditModal(true);
        }
      } catch (error) {
        if (handleApiError(error)) return;
 
        console.log("Error while updating Designation:", error);
      } finally {
        setIsEditLoading(false);
      }
    } else {
      setIsEditLoading(false);
    }
  };

  const handleEditSaveClick = () => {
    const newErrors = isEditValid();
    if (Object.keys(newErrors).length === 0) {
      setIsConfirming(true);
    } else {
      setShowEditModal(true);
      setIsConfirming(false);
    }
  };

  const handleConfirmSave = () => {
    handlEditDesignation();
    setShowEditModal(false);
    setIsConfirming(false);
  };

  const handleCancel = () => {
    setIsConfirming(false);
  };

  const handleEditClick = (designation) => {
    setIsConfirming(false);
    setSelectedDesignation(designation);

    setDesignationName(designation.name);
    setShowEditModal(true);
    setErrors(false);
  };

  //DELETE DESIGNATION
  const handleDeleteClick = (designation) => {
    setDesignationToDelete(designation);
    setShowDeleteModal(true);
  };
  const handleDeleteConfirm = async () => {
    try {
      if (designationToDelete) {
        await deleteDesignation(designationToDelete._id);
        setShowDeleteModal(false);
        setDesignationToDelete(null);
      }
    } catch (error) {
      console.error("Error while deleting unit:", error);
    }
  };

  const deleteDesignation = async (designationId) => {
    try {
      if (!accessToken) {
        console.warn("Access token is missing");
        return;
      }
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/V1/designation/deleteDesignation/${designationId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: accessToken,
            ip: await fetchIpAddress(),
          },
        }
      );
      if (response?.data?.data?.isInValidUser) {
        dispatch(setInValidUser(true));
      } else {
        dispatch(setInValidUser(false));
      }
      if (response.data.success) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        const totalRemainingItems = totalCount - 1; // Assuming `totalCount` is available from fetchDesignationData

        // Calculate the maximum number of pages after deletion
        const maxPages = Math.ceil(totalRemainingItems / limit);

        // If the current page is greater than maxPages, move to the previous page
        if (page > maxPages) {
          setPage(page - 1); // Decrease the page number
        }
        fetchDesignationData();
      }

      setTimeout(() => {}, 1000);
      return response.data;
    } catch (error) {
      if (handleApiError(error)) return;

      console.error("Error deleting unit:", error);
      throw error;
    }
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <div>
      <div className="main-content">
        <div className="Action-list-page">
          <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
            <h4>Add Designation</h4>
            <div>
              <BackButton show={camefromPreviousPage} />
            </div>
          </div>
          <div className="mt-2 table-box responsive-table">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-4">
                  <div className="form-group">
                    <label className="mb-1">
                      Designation<span className="star-mark"> *</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      autoComplete="off"
                      placeholder="Enter Designation Name"
                      onBlur={dsnameValidationCheck}
                      onChange={handleChange}
                      value={formValues.name}
                    />
                    {errors.name && (
                      <span className="error-message">{errors.name}</span>
                    )}
                  </div>
                </div>
              </div>
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <button
                  className="create-meeting-button Mom-btn"
                  disabled={isLoading}
                >
                  <p>Submit</p>
                </button>
              )}
            </form>
          </div>

          <div className="meeting-header-text  line-height-h4 mt-4">
            <h4 className="mt-2">Manage Designation(s)</h4>
          </div>
          <div className="mt-2 table-box responsive-table">
            <div className="d-flex align-items-center justify-content-between resp-flex-column mb-2">            
              <div className="tbl-text-search resp-unit-search w-100">
                <div className="left-tbl-text text-mb-3">
                  {totalCount > 0 ? (
                    <p>
                      Showing {fromDataCount} to {toDataCount} of {totalCount}{" "}
                      designation(s)
                    </p>
                  ) : null}
                </div>
                <div>
                  <div className="search-box position-relative unit-search">
                    <input
                      type="search"
                      autoComplete="off"
                      placeholder="Search By Designation"
                      value={searchKey}
                      onChange={handleSearch}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#4F2CC8"
                      className="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                    </svg>
                    {searchError && (
                      <span className="error-message">{searchError}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {isFetching ? (
              <div className="tbl-text-search">
                <div className="meeting-page loader-cont">
                  <Loader />
                </div>
              </div>
            ) : designation.length > 0 ? (
              <>
                <Table className="mt-4 table table-bordered table-striped unit-table">
                  <thead>
                    <tr>
                      <th className="text-align-center" style={{ width: "50px" }}>Sl. No.</th>
                      <th>Designations </th>
                      <th className="text-align-center">Updated At</th>
                      {window.innerWidth <= 768 ? null : (
                        <th scope="col" className="action-col">
                          Action
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {designation.map((designation, index) => {
                      return (
                        <tr key={index}>
                          <td
                            data-label="Sl. No."
                            className="text-align-center blue-bold-text"
                            style={{ width: "50px" }}
                          >
                            {index + 1 + (page - 1) * limit}
                          </td>
                          <td data-label="Designations" className="word-break">
                            {designation.name}

                            {window.innerWidth <= 768 ? (
                              <div className="d-inline-block menu-dropdown custom-dropdown inner1-drp resp-innerdrp-1">
                                <Dropdown>
                                  <div className="dropdown-opt d-inline-block menu-dropdown custom-dropdown">
                                    <Dropdown.Toggle id="dropdown-basic">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#000"
                                        className="bi bi-three-dots-vertical"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                      </svg>
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                      <Dropdown.Item
                                        onClick={() =>
                                          handleEditClick(designation)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="me-2 bi bi-pencil-square"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                          <path
                                            fillRule="evenodd"
                                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                          />
                                        </svg>
                                        Edit
                                      </Dropdown.Item>
                                      <hr className="dropdown-divider" role="separator" />
                                      <Dropdown.Item className="delete-drp"
                                        onClick={() =>
                                          handleDeleteClick(designation)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="18"
                                          fill="currentColor"
                                          className="me-2 bi bi-trash3"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                        </svg>
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </div>
                                </Dropdown>
                              </div>
                            ) : null}
                          </td>

                          <td data-label="Updated At"  className="text-align-center" >
                             <p className="detail-date-time">
                           <span>{designation.formattedDate}</span>
                           
                              <span className="text-secondary fs-12">{designation.formattedTime}</span>
                            </p>
                          </td>
                          {window.innerWidth <= 768 ? null : (
                            <td
                              data-label="Action"
                              className="text-align-center meeting-td-width-7"
                            >
                              <Dropdown>
                                <div className="dropdown-opt d-inline-block menu-dropdown custom-dropdown">
                                  <Dropdown.Toggle id="dropdown-basic">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="#000"
                                      className="bi bi-three-dots-vertical"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                    </svg>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleEditClick(designation)
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        fill="currentColor"
                                        className="me-2 bi bi-pencil-square"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path
                                          fillRule="evenodd"
                                          d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                        />
                                      </svg>
                                      Edit
                                    </Dropdown.Item>
                                    <hr className="dropdown-divider" role="separator" />
                                    <Dropdown.Item className="delete-drp"
                                      onClick={() =>
                                        handleDeleteClick(designation)
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        fill="currentColor"
                                        className="me-2 bi bi-trash3"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                                      </svg>
                                      Delete
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </div>
                              </Dropdown>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

                <div className="tbl-bottom">
                  <div className="left-tbl-bottom">
                    {/* Left Arrow Button */}
                    {page !== 1 ? (
                      <button
                        className="left-arrow"
                        onClick={() => setPage(page > 1 ? page - 1 : 1)}
                        disabled={page === 1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-chevron-left"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                          />
                        </svg>
                      </button>
                    ) : null}

                    {/* Pagination Component from MUI without arrows */}
                    <Stack spacing={2}>
                      <Pagination
                        count={totalPage}
                        page={page}
                        siblingCount={0}
                        boundaryCount={2}
                        onChange={handlePageChange}
                        hidePrevButton
                        hideNextButton
                        sx={{
                          "& .Mui-selected": {
                            backgroundColor: "#388d27 !important",
                            color: "#fff !important",
                          },
                        }}
                      />
                    </Stack>

                    {/* Right Arrow Button */}
                    {page < totalPage ? (
                      <button
                        className="right-arrow"
                        onClick={() =>
                          setPage(page * limit < totalCount ? page + 1 : page)
                        }
                        disabled={page * limit >= totalCount}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="#fff"
                          className="bi bi-chevron-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                          />
                        </svg>
                      </button>
                    ) : null}
                  </div>

                  {/* Rows Per Page Selector */}
                  <div className="right-tbl-bottom">
                    <p>Rows Per Page</p>
                    <select
                      className="no-opt-box"
                      name="limit"
                      onChange={handleRowsPerPageChange}
                      value={limit}
                    >
                      {Array.from({ length: maxOption / 5 }).map((_, index) => {
                        const value = (index + 1) * 5;
                        return (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </>
            ) : (
              <div className="no-data-img mt-3">
                <>
                  <Alert
                    status={"info"}
                    message={"No data available."}
                    timeoutSeconds={0}
                  />
                  <NoDataFound dataType={"meeting"} />
                  <div className="button-outer">
                    <Button variant="primary" onClick={handleClearSearch}>
                      Clear
                    </Button>
                  </div>
                </>
              </div>
            )}
          </div>
          <Modal
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Designation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {isConfirming ? (
                // Confirmation view
                <p>Are you sure you want to update this designation?</p>
              ) : (
                // Edit form view
                <Form>
                  <Form.Group controlId="designationName">
                    <Form.Label>
                      Designation<span className="star-mark"> *</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Designation"
                      value={designationName}
                      autoComplete="off"
                      onKeyDown={handleKeyDown}
                      onChange={(e) => setDesignationName(e.target.value)}
                      onBlur={editDesignationValidationCheck}
                    />
                  </Form.Group>
                  {errors.designationName && (
                    <span className="error-message">
                      {errors.designationName}
                    </span>
                  )}
                </Form>
              )}
            </Modal.Body>
            <Modal.Footer>
              {isConfirming ? (
                <>
                  <Button
                    variant=""
                    className="add-minutes Mom-btn"
                    onClick={handleCancel}
                  >
                    <p>Cancel</p>{" "}
                  </Button>
                  <Button
                    variant=""
                    className="create-meeting-button Mom-btn"
                    onClick={handleConfirmSave}
                  >
                    <p>Confirm Update</p>
                  </Button>
                </>
              ) : (
                <Button
                  variant=""
                  className="create-meeting-button Mom-btn"
                  onClick={handleEditSaveClick}
                >
                  <p>Save Changes</p>
                </Button>
              )}
            </Modal.Footer>
          </Modal>
          <Modal
            show={showDeleteModal}
            onHide={() => setShowDeleteModal(false)}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this Designations ?
            </Modal.Body>
            <Modal.Footer>
              {isLoading ? (
                <SmallLoaderButton />
              ) : (
                <Button
                  variant=""
                  className="add-minutes Mom-btn"
                  onClick={handleDeleteConfirm}
                >
                  <p>Delete</p>
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  )
}

export default Designation